import { PropsWithChildren } from "react";

const Layers: React.FC<PropsWithChildren> = ({ children }) => <>{children}</>;

export default Layers;
